import { Record } from 'immutable';

export default class EmploymentContractPreviewRecord extends Record({
  id: undefined,
  generatedHtml: undefined,
  links: undefined,
}) {
}
